module.exports = __webpack_public_path__ + "img/294.18e31a30.jpg";